import { defineMessages, FormattedMessage } from 'react-intl';

const documentTypeMessages = defineMessages({
    agedDebtorReport: {
        id: '_.trading_data.choose_document_type.action.aged_debtor_report',
        defaultMessage: 'Aged Debtor Report'
    },
    vatReturn: {
        id: '_.trading_data.choose_document_type.action.vat_return',
        defaultMessage: 'VAT Return'
    },
    bankStatement: {
        id: '_.trading_data.choose_document_type.action.bank_statement',
        defaultMessage: 'Bank Statement'
    },
    businessPlan: {
        id: '_.trading_data.choose_document_type.action.business_plan',
        defaultMessage: 'Business Plan'
    },
    filedAccounts: {
        id: '_.trading_data.choose_document_type.action.filed_accounts',
        defaultMessage: 'Filed Accounts'
    },
    managementAccounts: {
        id: '_.trading_data.choose_document_type.action.management_accounts',
        defaultMessage: 'Management Accounts'
    },
    personalID: {
        id: '_.trading_data.choose_document_type.action.personal_id',
        defaultMessage: 'Personal ID'
    },
    shareholderID: {
        id: '_.trading_data.choose_document_type.action.shareholder_id',
        defaultMessage: 'Shareholder ID'
    },
    shareholderRegistry: {
        id: '_.trading_data.choose_document_type.action.shareholder_registry',
        defaultMessage: 'Share Registry'
    },
    businessAccounts: {
        id: '_.trading_data.choose_document_type.action.business_accounts',
        defaultMessage: 'Business Accounts'
    },
    companyBylaws: {
        id: '_.trading_data.choose_document_type.action.company_by_laws',
        defaultMessage: 'Company Bylaws'
    },
    tradeCertificate: {
        id: '_.trading_data.choose_document_type.action.trade_certificate',
        defaultMessage: 'Trade Certificate'
    },
    articlesOfAssociation: {
        id: '_.trading_data.choose_document_type.action.articles_of_association',
        defaultMessage: 'Articles of Association'
    },
    selfAssessmentTaxReturn: {
        id: '_.trading_data.choose_document_type.action.self_assessment_tax_return',
        defaultMessage: 'Self Assessment Tax Return'
    },
    personalBankStatement: {
        id: '_.trading_data.choose_document_type.action.personal_bank_statement',
        defaultMessage: 'Personal Bank Statement'
    },
    limitedPartnerID: {
        id: '_.trading_data.choose_document_type.action.limited_partner_id',
        defaultMessage: 'Limited Partner ID'
    },
    PNLBalance: {
        id: '_.trading_data.choose_document_type.action.pnl_balance',
        defaultMessage: 'PnL Balance'
    },
    profitAndLoss: {
        id: '_.trading_data.choose_document_type.action.profit_and_loss',
        defaultMessage: 'Profit and Loss'
    },
    customerBrokerConsent: {
        id: '_.trading_data.choose_document_type.action.customer_broker_consent',
        defaultMessage: 'Customer Broker Consent'
    },
    cashRegister: {
        id: '_.trading_data.choose_document_type.action.cash_register',
        defaultMessage: 'Cash Register'
    },
    certificados: {
        id: '_.trading_data.choose_document_type.action.certificados',
        defaultMessage: 'Certificados'
    },
    balanceSheet: {
        id: '_.trading_data.choose_document_type.action.balance_sheet',
        defaultMessage: 'Balance Sheet'
    },
    managementAndBalanceAccounts: {
        id: '_.trading_data.choose_document_type.action.management_and_balance_accounts',
        defaultMessage: 'Management and Balance Accounts'
    },
    yearEndManagementAndBalanceAccounts: {
        id: '_.trading_data.choose_document_type.action.year_end_management_and_balance_accounts',
        defaultMessage: 'Year End Management and Balance Accounts'
    },
    yearEndManagementAccounts: {
        id: '_.trading_data.choose_document_type.action.year_end_management_accounts',
        defaultMessage: 'Year End Management Accounts'
    },
    accountBalances: {
        id: '_.trading_data.choose_document_type.action.account_balances',
        defaultMessage: 'Account Balances'
    },
    outstandingDebtInformation: {
        id: '_.trading_data.choose_document_type.action.outstanding_debt_information',
        defaultMessage: 'Debt Position'
    },
    cashflowForecast: {
        id: '_.trading_data.choose_document_type.action.cashflow_forecast',
        defaultMessage: 'Cashflow forecast'
    },
    listOfShareholders: {
        id: '_.trading_data.choose_document_type.action.list_of_shareholders',
        defaultMessage: 'List of shareholders'
    },
    other: {
        id: '_.trading_data.choose_document_type.action.other',
        defaultMessage: 'Other'
    }
});

export const DocumentTypeLabel = ({ label }: { label: string }) => (
    <FormattedMessage
        // eslint-disable-next-line local/no-spread-messages -- colocated dictionary lookup
        {...documentTypeMessages[label as keyof typeof documentTypeMessages]}
    />
);
